/** Native Analytics cards provide the graphic. Keep explanations as prose, and
 * avoid displaying a second, unsupported diagram definition above that card.
 * Ordinary documents and explicitly requested source code remain untouched.
 */
export function chartSourceRequested(request:string):boolean {
  if(/\b(?:no|without)\s+(?:source\s+)?code\b|\b(?:don['’]?t|do\s+not)\s+(?:show|include|give|write|emit)\b[^.!?\n]{0,50}\b(?:code|syntax)\b/i.test(request))return false;
  return /\b(?:show|give|write|include|provide|return|export|generate)\b[^.!?\n]{0,60}\b(?:code|syntax)\b|\b(?:mermaid|vega(?:-lite)?|plotly)\s+(?:source|code|syntax)\b/i.test(request);
}
export function analyticsChatNarrative(text:string,hasNativeCard:boolean,request=''):string {
  if(!hasNativeCard||chartSourceRequested(request))return text;
  const lines=text.split('\n'),kept:string[]=[];
  for(let index=0;index<lines.length;index++){
    const open=/^\s{0,3}(`{3,}|~{3,})\s*([^\s]*)[^\n]*$/.exec(lines[index]);
    if(!open){kept.push(lines[index]);continue;}
    const marker=open[1][0],length=open[1].length,language=open[2].toLowerCase();
    let end=index+1;
    for(;end<lines.length;end++){const close=/^\s{0,3}([`~]+)\s*$/.exec(lines[end]);if(close&&close[1][0]===marker&&close[1].length>=length&&Array.from(close[1]).every(c=>c===marker))break;}
    const diagram=/^(?:mermaid|vega|vega-lite|plotly)$/.test(language)||(!language&&/^\s*(?:xychart(?:-beta)?|pie\s+title|quadrantChart|sankey-beta)\b/.test(lines[index+1]||''));
    if(!diagram)kept.push(...lines.slice(index,Math.min(end+1,lines.length)));
    index=end;
  }
  return kept.join('\n').replace(/\n{3,}/g,'\n\n').trim();
}
